var _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgTabit(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 24,
    viewBox: "0 0 330 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1364_279)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.327 28.791C246.976 28.791 240.248 21.3579 240.248 14.4492C240.248 7.95756 245.923 0 256.327 0C266.732 0 272.722 7.95756 272.722 14.4492C272.722 22.1961 266.943 28.791 256.327 28.791Z",
    fill: "#0F5853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.779 86.166H242.034V52.9769H236.779V34.7578H271.462V86.0628H276.821V104.278H236.779V86.166Z",
    fill: "#0F5853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.751 87.1089C322.642 87.1089 328.213 85.8535 330 84.8046V102.706C326.531 104.383 316.125 105.324 312.763 105.324C290.799 105.324 290.065 93.9144 290.065 76.0089V51.302H281.343V33.1898H290.065V19.996L316.021 11.7246V33.1857H329.896V51.2978H316.021V76.005C316.125 80.7166 315.076 87.1009 320.751 87.1009V87.1089Z",
    fill: "#0F5853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.685 35.4934C219.232 35.4934 230.789 52.8747 230.37 70.9868C229.951 91.9273 217.549 105.852 197.581 105.852C192.222 105.852 188.545 105.117 185.705 103.969V93.0398C185.705 89.7067 188.417 87.005 191.763 87.005H195.795C195.795 87.005 196.214 55.2822 179.189 51.4088V104.283H142.931V90.251C142.931 88.5467 144.083 87.0965 145.715 86.588C149.029 85.5551 151.337 82.7503 151.337 79.6794V20.5199H144.61V3.24609H178.978V41.8777C182.236 38.4213 190.642 35.4895 197.685 35.4895V35.4934Z",
    fill: "#0F5853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.874 51.6155H142.197V77.4744H143.98C145.028 77.4744 145.878 76.6282 145.878 75.5835V51.6113L145.874 51.6155Z",
    fill: "#0F5853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.779 51.6152H134.102V75.5871C134.102 76.6318 134.951 77.478 136 77.478H137.782V51.6191L137.779 51.6152Z",
    fill: "#0F5853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.518 90.3022V104.386H106.146L102.784 98.3112C97.5284 105.22 88.7031 107 83.5507 107C70.0994 107 55.4917 100.091 55.4917 84.3866C55.4917 68.682 68.9429 59.469 85.1299 59.469C93.5366 59.469 98.5811 63.4458 99.2114 64.284V59.469C99.2114 53.3985 93.4328 51.9326 85.7602 51.9326C77.3535 51.9326 69.9957 55.2817 64.5322 58.2135L58.5426 42.5092C64.2174 39.2632 76.4084 32.875 89.5445 32.875C106.677 32.875 128.116 38.9493 128.116 60.8279V79.9886C128.032 82.8889 130.648 85.7253 133.882 86.7822C135.433 87.2908 136.522 88.6773 136.522 90.3022H136.518ZM99.1035 84.8036V79.6747C98.681 79.047 96.687 75.6979 90.6971 75.6979C85.0223 75.6979 82.4979 78.7331 82.4979 82.9207C82.4979 86.6907 85.756 89.3089 89.9592 89.3089C94.1627 89.3089 97.7356 86.9014 99.1035 84.8078V84.8036Z",
    fill: "#0F5853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4127 88.3627C41.3029 88.3627 46.874 87.1072 48.6604 86.0583V103.96C45.191 105.636 34.7865 106.578 31.4249 106.578C9.45935 106.578 8.72556 95.164 8.72556 77.2626V52.5554H0V34.4436H8.72157V21.1464L34.6788 12.875V34.3363H48.5528V52.5554H34.6788V77.1592C34.6788 81.9742 33.6261 88.3627 39.4085 88.3627H39.4127Z",
    fill: "#0F5853"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1364_279"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 330,
    height: 107,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgTabit);
export default __webpack_public_path__ + "static/media/img_tabit.0a452f6b91b35795c42a57347057746d.svg";
export { ForwardRef as ReactComponent };